/**
 * Schedule event in the schedule page.
 * This is the main object used for ScheduleEvent components.
 */
export class ScheduleEvt {

  // ===========================
  // Event data from the backend
  /**
   * ID of the event
   * @type {Number}
   */
  id = 1;

  /**
   * Name of the event
   * @type {String}
   */
  name = '';

  /**
   * Type of the event. 1 for meeting, 2 for field tour
   * @type {Number}
   */
  type = 1;

  /**
   * Duration of the event in seconds
   * @type {Number}
   */
  duration = 0;

  /**
   * Time of the event as defined in the database 'HH:mm'
   * @type {String}
   */
  time = '00:00';

  /**
   * Steps of the event (steps of the meeting or of the field tour)
   * @type {Array}
   */
  steps = [];

  // =====================
  // Style and positioning
  /**
   * If this event is part of a group, this is the ID of the event that forms the group
   * @type {Number}
   */
  inGroup = 0;

  /**
   * If this array is filled with events, the obejct actually represents a group of events and not a single one
   * @type {Array}
   */
  groupedEvents = [];

  /**
   * TimeOne of scheduleEventColors constants
   * @type {String}
   */
  color = 'pdcaPlan';

  /**
   * Whether this event should be absolutely positioned in the calendar
   * @type {Boolean}
   */
  absolute = false;

  /**
   * Top position in pixels of the event
   * @type {Boolean}
   */
  topPosition = 0;

  /**
   * If not null, define the item as a half width item in order to place two events on the same line
   * @type {Object}
   */
  halfWidth = null;


  constructor(props) {
    this.time = props.time || '';
    this.duration = props.duration || 0;
    this.type = props.type || 1;
    this.name = props.name || '';
    this.id = props.id || 0;
    this.steps = props.steps || [];
    Object.keys(props).forEach((key) => {
      this[key] = props[key];
    });
  }
}

export const scheduleEventColors = [
  'pdcaPlan',
  'pdcaDo',
  'pdcaCheck',
  'pdcaAct',
];


export default {
  ScheduleEvt,
  scheduleEventColors,
};
